import React, { useEffect, useState, useRef } from 'react';
import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row, Button, Spinner } from 'reactstrap';
import { maxLengthCheck, toCamelCase } from '../../utils/helper';
import '../DonarPublicPage/DonarPublicPage.css';
import { toast, Zoom } from 'react-toastify';
import { Donation_bill_Details_Public, RegisterPersoneEvent_Public } from '../../api/DonationBillApi/DonationCillapi';
import { fetchPublicEventDetail, verifyEventPayment, failEventPayment, updatePublicEventRegistration } from '../../api/Events/EventsApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DonarPublicHeaderComponent from '../../common/commonComp';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DialCodeList } from '../../api/DialCodeApi/DialCodeApi';
import { MapPin, Navigation } from 'react-feather';
import { FILE_API } from '../../api/Bank Master api/BankMasterAPi';
import { CLIENT_TYPE } from '../../constant';

const EventPublicRegistration = () => {
  const [searchParams] = useSearchParams();
  const eventUuid = searchParams.get('eventUuid');
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [eventDetail, setEventDetail] = useState(null);
  const [click, setClick] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Participant fixed details
  const [name, setName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [nameConfig, setNameConfig] = useState('single');
  const [contactNo, setContactNo] = useState('');
  const [isMobileFromParam, setIsMobileFromParam] = useState(false);
  const [dialCode, setDialCode] = useState('+91');
  const [dialCodeJson, setDialCodeJson] = useState([]);
  const [gender, setGender] = useState('male');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const cityRef = useRef(null);

  // Custom responses
  const [responses, setResponses] = useState({});

  // Auth token and existing registration status
  const [personToken, setPersonToken] = useState('');
  const [isAlreadyRegistered, setIsAlreadyRegistered] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    setDialCodeJson(DialCodeList());
  }, []);

  useEffect(() => {
    if (!eventUuid) {
      toast.error("Invalid registration link: Event UUID is missing.");
      setLoading(false);
      return;
    }
    loadEventDetails();
  }, [eventUuid]);

  const loadEventDetails = async () => {
    try {
      const { data } = await fetchPublicEventDetail(eventUuid);
      if (data.status === 200 && data.payload?.data) {
        const detail = data.payload.data;
        if (detail.formFields) {
          if (typeof detail.formFields === 'string') {
            try {
              detail.formFields = JSON.parse(detail.formFields);
            } catch (e) {
              console.error("Error parsing formFields:", e);
              detail.formFields = [];
            }
          }
          if (!Array.isArray(detail.formFields)) {
            try {
              detail.formFields = Object.values(detail.formFields);
            } catch (e) {
              detail.formFields = [];
            }
          }

          // Extract nameConfig if defined
          const configField = detail.formFields.find(f => f.fieldKey === 'name_config');
          setNameConfig(configField ? configField.label : 'single');
          detail.formFields = detail.formFields.filter(f => f.fieldKey !== 'name_config');
        } else {
          detail.formFields = [];
          setNameConfig('single');
        }
        setEventDetail(detail);

        // Auto-fill mobile and fetch user details if mobile parameter is present in URL
        const mobileParam = searchParams.get('mobile');
        if (mobileParam) {
          setIsMobileFromParam(true);
          let cleaned = mobileParam.replace(/[\s\+]/g, ''); // remove spaces and '+'
          let finalDialCode = '+91';
          let finalContact = '';

          if (cleaned.length === 10) {
            finalContact = cleaned;
          } else if (cleaned.startsWith('91') && cleaned.length === 12) {
            finalContact = cleaned.substring(2);
            finalDialCode = '+91';
          } else if (cleaned.length > 10) {
            finalContact = cleaned.slice(-10);
            finalDialCode = '+' + cleaned.slice(0, -10);
          } else {
            finalContact = cleaned;
          }

          setDialCode(finalDialCode);
          setContactNo(finalContact);

          if (finalContact.length === 10) {
            await showHandle(`${finalDialCode} ${finalContact}`, detail.orgId);
          }
        }
      } else {
        toast.error("Event details not found");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error loading event registration form");
    } finally {
      setLoading(false);
    }
  };

  const pageItemUploadFile = async ({ files, type }) => {
    let formData1 = new FormData();
    formData1.append('type', type);
    formData1.append('file', files[0]);

    try {
      const { data } = await FILE_API(formData1);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });

        return {
          imageUrl: data.payload.imageUrl,
          baseUrl: data.payload.baseUrl
        };
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "File upload error", {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const clearFormFields = () => {
    setName('');
    setFirstName('');
    setLastName('');
    setGender('male');
    setAddress('');
    setCity('');
    setResponses({});
    setPersonToken('');
    setIsAlreadyRegistered(false);
    setPaymentStatus(null);
  };

  const showHandle = async (mobileNum, orgId) => {
    try {
      const { data } = await Donation_bill_Details_Public({ mobile: mobileNum, orgId, eventUuid });
      if (data.status === 200 && data.payload?.data) {
        const person = data.payload.data;
        setName(person.name || '');
        if (person.name) {
          const parts = person.name.trim().split(/\s+/);
          if (parts.length > 1) {
            setFirstName(parts[0]);
            setLastName(parts.slice(1).join(' '));
          } else {
            setFirstName(person.name);
            setLastName('');
          }
        } else {
          setFirstName('');
          setLastName('');
        }
        setGender(person.gender || 'male');
        setAddress(person.address || '');
        setCity(person.city || '');
        
        setIsAlreadyRegistered(!!data.payload?.alreadyRegistered);
        setPaymentStatus(data.payload?.paymentStatus || null);
        if (data.payload?.personToken) {
          setPersonToken(data.payload.personToken);
        }

        // Auto-populate responses if custom field key matches standard person column.
        // The admin form builder forces fieldKey to lowercase (e.g. idprooffront), so we
        // populate both the camelCase and lowercase variants to match either format.
        setResponses((prev) => {
          const updatedResponses = { ...prev };

          // Merge lastResponses if present
          if (data.payload?.lastResponses) {
            Object.assign(updatedResponses, data.payload.lastResponses);
            Object.keys(data.payload.lastResponses).forEach((k) => {
              updatedResponses[k.toLowerCase()] = data.payload.lastResponses[k];
            });
          }

          const personKeys = ['gender', 'address', 'village', 'panCardNo', 'aadhaarCard', 'dob', 'city', 'state', 'country', 'pinCode', 'idProofFront', 'idProofBack'];
          personKeys.forEach((key) => {
            if (person[key] !== undefined && person[key] !== null && person[key] !== '') {
              let val;
              if (key === 'dob') {
                val = moment(person[key]).format('YYYY-MM-DD');
              } else {
                val = person[key];
              }
              // Populate both camelCase (idProofFront) and lowercase (idprooffront) variants
              updatedResponses[key] = val;
              updatedResponses[key.toLowerCase()] = val;
            }
          });
          return updatedResponses;
        });
      } else {
        clearFormFields();
        setIsAlreadyRegistered(false);
        setPersonToken('');
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      clearFormFields();
      setIsAlreadyRegistered(false);
      setPersonToken('');
    }
  };

  const handleContactChange = async (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
    setContactNo(value);
    if (value.length === 10 && eventDetail) {
      await showHandle(`${dialCode} ${value}`, eventDetail.orgId);
    } else {
      clearFormFields();
    }
  };

  const handleChangeDialCode = async (e) => {
    const value = e.target.value;
    setDialCode(value);
    if (value && contactNo.length === 10 && eventDetail) {
      await showHandle(`${value} ${contactNo}`, eventDetail.orgId);
    } else {
      clearFormFields();
    }
  };

  const fetchCityFromCoordinates = async (lat, lon) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`, {
        headers: {
          'Accept-Language': 'en'
        }
      });
      if (response.ok) {
        const data = await response.json();
        if (data && data.address) {
          const cityName = data.address.city || data.address.town || data.address.village || data.address.suburb || data.address.county || "";
          if (cityName) {
            // Only auto-populate city if it is empty/blank
            if (!city || !city.trim()) {
              setCity(cityName);
              toast.success(`City detected: ${cityName}`, { autoClose: 2000 });
              if (cityRef.current) {
                cityRef.current.focus();
              }
            } else {
              toast.info(`Skipped setting city (Location detected: ${cityName}, but field is already filled)`, { autoClose: 3000 });
            }
          }
        }
      }
    } catch (error) {
      console.error("Error fetching city from coordinates:", error);
    }
  };

  const handleGetLocation = (fieldKey) => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }
    toast.info("Retrieving location...");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const coordinates = `${latitude},${longitude}`;
        setResponses((prev) => ({
          ...prev,
          [fieldKey]: coordinates
        }));
        toast.success("Location retrieved successfully!");
        fetchCityFromCoordinates(latitude, longitude);
      },
      (error) => {
        toast.error("Unable to retrieve location. Please grant permission or enter it manually.");
      }
    );
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const calculateRegistrationFee = () => {
    if (!eventDetail || !eventDetail.isPaymentEnabled) return 0;
    const baseAmount = parseFloat(eventDetail.amount || 0);
    let optionPricesSum = 0;

    const extractPriceFromOption = (optionText) => {
      if (!optionText || typeof optionText !== 'string') return null;
      const pattern1 = /(\d+(?:\.\d+)?)\s*(?:(?:\/-)|(?:રૂ)|(?:rs\.?)|(?:inr))/i;
      const match1 = optionText.match(pattern1);
      if (match1) return parseFloat(match1[1]);
      const pattern2 = /\((\d+(?:\.\d+)?)\)/;
      const match2 = optionText.match(pattern2);
      if (match2) return parseFloat(match2[1]);
      return null;
    };

    if (eventDetail.formFields && responses) {
      let fields = eventDetail.formFields;
      if (Array.isArray(fields)) {
        fields.forEach(field => {
          if (['dropdown', 'radio', 'checkbox'].includes(field.type)) {
            const fieldKeyLower = field.fieldKey.toLowerCase();
            let userResponse = responses[field.fieldKey];
            if (userResponse === undefined || userResponse === null) {
              for (const key of Object.keys(responses)) {
                if (key.toLowerCase() === fieldKeyLower) {
                  userResponse = responses[key];
                  break;
                }
              }
            }

            if (userResponse !== undefined && userResponse !== null) {
              if (Array.isArray(userResponse)) {
                userResponse.forEach(opt => {
                  const price = extractPriceFromOption(opt);
                  if (price !== null) optionPricesSum += price;
                });
              } else if (typeof userResponse === 'string') {
                const price = extractPriceFromOption(userResponse);
                if (price !== null) optionPricesSum += price;
              }
            }
          }
        });
      }
    }

    return optionPricesSum > 0 ? optionPricesSum : baseAmount;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    let fullName = '';
    if (nameConfig === 'split') {
      if (!firstName || !firstName.trim()) {
        toast.error("Please enter First Name");
        return;
      }
      if (!lastName || !lastName.trim()) {
        toast.error("Please enter Last Name");
        return;
      }
      fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
    } else {
      if (!name || !name.trim()) {
        toast.error("Please enter Name");
        return;
      }
      fullName = name.trim();
    }

    if (!contactNo || contactNo.trim().length !== 10) {
      toast.error("Please enter a valid 10-digit contact number");
      return;
    }
    if (!gender) {
      toast.error("Please select gender");
      return;
    }
    if (!address || !address.trim()) {
      toast.error("Please enter address");
      return;
    }
    if (!city || !city.trim()) {
      toast.error("Please enter city");
      return;
    }

    setClick(true);
    setErrorMessage('');
    try {
      const cleanedResponses = { ...responses };
      if (eventDetail.formFields) {
        eventDetail.formFields.forEach(f => {
          if (f.type === 'label') {
            delete cleanedResponses[f.fieldKey];
          }
        });
      }

      const payload = {
        mobile: `${dialCode} ${contactNo}`,
        name: fullName,
        gender,
        address,
        city,
        orgId: eventDetail.orgId,
        templeId: eventDetail.templeId,
        eventUuid: eventDetail.eventUuid,
        responses: {
          ...cleanedResponses,
          gender,
          address,
          city,
          ...(nameConfig === 'split' ? {
            firstname: firstName.trim(),
            lastname: lastName.trim(),
            firstName: firstName.trim(),
            lastName: lastName.trim()
          } : {})
        }
      };

      const isPaid = paymentStatus === 'paid';
      if (isAlreadyRegistered && isPaid) {
        if (!eventDetail.isEditableByUser) {
          toast.error("This registration is already submitted and cannot be modified.");
          setClick(false);
          return;
        }

        const updatePayload = {
          personToken,
          eventUuid: eventDetail.eventUuid,
          responses: {
            ...cleanedResponses,
            gender,
            address,
            city,
            ...(nameConfig === 'split' ? {
              firstname: firstName.trim(),
              lastname: lastName.trim(),
              firstName: firstName.trim(),
              lastName: lastName.trim()
            } : {})
          }
        };

        const { data } = await updatePublicEventRegistration(updatePayload);
        if (data.status === 200) {
          toast.success("Registration updated successfully!", {
            autoClose: 1500,
            transition: Zoom
          });
          navigate(`/Thankyou/${eventDetail.orgId}/${eventDetail.templeId}?type=event&eventUuid=${eventDetail.eventUuid}`);
        }
        setClick(false);
        return;
      }

      const { data } = await RegisterPersoneEvent_Public(payload);
      if (data.status === 200) {
        // Check if payment is required
        if (data.payload && data.payload.paymentRequired) {
          const scriptLoaded = await loadRazorpayScript();
          if (!scriptLoaded) {
            toast.error("Razorpay SDK failed to load. Are you online?");
            setClick(false);
            return;
          }

          const options = {
            key: data.payload.key,
            amount: data.payload.amount,
            currency: data.payload.currency,
            name: eventDetail.eventName || "Event Registration",
            description: "Registration Payment",
            order_id: data.payload.orderId,
            handler: async function (response) {
              const loadingToast = toast.info("Verifying payment...", { autoClose: false });
              try {
                const { data: verifyData } = await verifyEventPayment({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature,
                  eventUuid: eventDetail.eventUuid
                });
                
                if (verifyData.status === 200) {
                  toast.success("Payment verified and registration completed successfully!");
                  setName('');
                  setFirstName('');
                  setLastName('');
                  setContactNo('');
                  setGender('male');
                  setAddress('');
                  setCity('');
                  setResponses({});
                  setErrorMessage('');
                  navigate(`/Thankyou/${eventDetail.orgId}/${eventDetail.templeId}?type=event&eventUuid=${eventDetail.eventUuid}`);
                } else {
                  toast.error(verifyData.message || "Verification failed");
                }
              } catch (err) {
                const errMsg = err?.response?.data?.message || "Payment verification failed";
                setErrorMessage(errMsg);
                toast.error(errMsg);
              } finally {
                toast.dismiss(loadingToast);
                setClick(false);
              }
            },
            modal: {
              ondismiss: async function () {
                try {
                  await failEventPayment({
                    razorpay_order_id: data.payload.orderId,
                    eventUuid: eventDetail.eventUuid
                  });
                } catch (err) {
                  console.error("Error reporting failed payment:", err);
                }
                toast.error("Payment cancelled.");
                setClick(false);
              }
            },
            prefill: {
              name: fullName,
              contact: contactNo
            },
            theme: {
              color: "#7c3abf"
            }
          };

          const paymentObject = new window.Razorpay(options);
          paymentObject.open();
        } else {
          // Free event logic
          toast.success(data.message || "Registration completed successfully!", {
            autoClose: 1500,
            transition: Zoom
          });
          setName('');
          setFirstName('');
          setLastName('');
          setContactNo('');
          setGender('male');
          setAddress('');
          setCity('');
          setResponses({});
          setErrorMessage('');
          navigate(`/Thankyou/${eventDetail.orgId}/${eventDetail.templeId}?type=event&eventUuid=${eventDetail.eventUuid}`);
        }
      } else {
        const msg = data.message || "Failed to register";
        setErrorMessage(msg);
        toast.error(msg);
        setClick(false);
      }
    } catch (error) {
      const serverMessage = error?.response?.data?.message || error?.response?.data?.payload?.error || "Failed to register. Please check input requirements.";
      setErrorMessage(serverMessage);
      toast.error(serverMessage);
      setClick(false);
    }
  };

  // Helper: convert basic markdown formatting to HTML for label fields
  // Supports: **bold**, *italic*, URLs to clickable links, \n (literal or real newline) → <br/>
  const formatLabelText = (text) => {
    if (!text) return '';
    let html = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    
    // Replace URLs with clickable <a> links, excluding trailing punctuation and newlines
    html = html.replace(
      /(https?:\/\/[^\s<\\]+[^.,:;"'()!?\s<\\])/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; font-weight: bold; color: #7366ff;">$1</a>'
    );

    // Parse parenthesized markdown link brackets e.g. [Label](<a href="URL"...>URL</a>)
    html = html.replace(
      /\[([^\]]+)\]\(<a href="([^"]+)"[^>]*>.*?<\/a>\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; font-weight: bold; color: #7366ff;">$1</a>'
    );

    html = html
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/\\n|\n/g, '<br/>');   // handles both literal \n text and actual newline (Enter)
    return html;
  };

  const renderDynamicField = (field) => {
    const fieldKey = field.fieldKey;
    const value = responses[fieldKey] || '';
    const isRequired = field.required;
    const isPaid = paymentStatus === 'paid';
    const isDisabled = isAlreadyRegistered && (isPaid ? !field.isEditable : !eventDetail?.isEditableByUser);

    const handleInputChange = (e) => {
      if (isDisabled) return;
      let val = e.target ? e.target.value : e;
      if (field.type === 'number') {
        val = val.replace(/[^0-9.]/g, '');
        const parts = val.split('.');
        if (parts.length > 2) {
          val = parts[0] + '.' + parts.slice(1).join('');
        }
      } else if (field.type === 'phone') {
        val = val.replace(/[^0-9\s+-]/g, '');
      }

      setResponses(prev => ({
        ...prev,
        [fieldKey]: val
      }));

      if (field.type === 'mapLocation') {
        const match = val.match(/^([-+]?[0-9]*\.?[0-9]+),\s*([-+]?[0-9]*\.?[0-9]+)$/);
        if (match) {
          const lat = parseFloat(match[1]);
          const lon = parseFloat(match[2]);
          if (!isNaN(lat) && !isNaN(lon)) {
            fetchCityFromCoordinates(lat, lon);
          }
        }
      }
    };

    switch (field.type) {
      case 'text':
      case 'email':
        return (
          <Input
            type={field.type}
            className="form-control colorBlack"
            placeholder={field.label}
            value={value}
            onChange={handleInputChange}
            required={isRequired}
            disabled={isDisabled}
            style={{ borderRadius: "8px" }}
          />
        );
      case 'phone':
        return (
          <Input
            type="tel"
            className="form-control colorBlack"
            placeholder={field.label}
            value={value}
            onChange={handleInputChange}
            required={isRequired}
            disabled={isDisabled}
            style={{ borderRadius: "8px" }}
          />
        );
      case 'number':
        return (
          <Input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className="form-control colorBlack"
            placeholder={field.label}
            value={value}
            onChange={handleInputChange}
            required={isRequired}
            disabled={isDisabled}
            style={{ borderRadius: "8px" }}
          />
        );
      case 'textarea':
        return (
          <Input
            type="textarea"
            rows="3"
            className="form-control colorBlack"
            placeholder={field.label}
            value={value}
            onChange={handleInputChange}
            required={isRequired}
            disabled={isDisabled}
            style={{ borderRadius: "8px" }}
          />
        );
      case 'dropdown':
        return (
          <Input
            type="select"
            className="form-control colorBlack"
            value={value}
            onChange={handleInputChange}
            required={isRequired}
            disabled={isDisabled}
            style={{ borderRadius: "8px" }}
          >
            <option value="">Select Option</option>
            {field.options && field.options.map((opt, idx) => (
              <option key={idx} value={opt}>{opt}</option>
            ))}
          </Input>
        );
      case 'radio':
        return (
          <div className="d-flex flex-wrap align-items-center mt-2" style={{ gap: '1.5rem' }}>
            {field.options && field.options.map((opt, idx) => (
              <FormGroup check key={idx} className="mb-0">
                <Label check style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', fontWeight: '500' }}>
                  <Input
                    type="radio"
                    name={fieldKey}
                    value={opt}
                    checked={value === opt}
                    onChange={handleInputChange}
                    required={isRequired}
                    disabled={isDisabled}
                  />{' '}
                  {opt}
                </Label>
              </FormGroup>
            ))}
          </div>
        );
      case 'checkbox': {
        const checkedValues = Array.isArray(value) ? value : [];
        const handleCheckboxChange = (optValue, isChecked) => {
          if (isDisabled) return;
          let updated;
          if (isChecked) {
            updated = [...checkedValues, optValue];
          } else {
            updated = checkedValues.filter(v => v !== optValue);
          }
          setResponses(prev => ({
            ...prev,
            [fieldKey]: updated
          }));
        };
        return (
          <div className="d-flex flex-wrap align-items-center mt-2" style={{ gap: '1.5rem' }}>
            {field.options && field.options.map((opt, idx) => (
              <FormGroup check key={idx} className="mb-0">
                <Label check style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', fontWeight: '500' }}>
                  <Input
                    type="checkbox"
                    value={opt}
                    checked={checkedValues.includes(opt)}
                    onChange={(e) => handleCheckboxChange(opt, e.target.checked)}
                    disabled={isDisabled}
                  />{' '}
                  {opt}
                </Label>
              </FormGroup>
            ))}
          </div>
        );
      }
      case 'date':
        return (
          <div className="custom-datepicker-wrapper">
            <DatePicker
              className="form-control colorBlack w-100"
              selected={value ? new Date(value) : null}
              onChange={(date) => {
                if (isDisabled) return;
                const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
                setResponses(prev => ({
                  ...prev,
                  [fieldKey]: formatted
                }));
              }}
              dateFormat="yyyy-MM-dd"
              placeholderText={field.label}
              required={isRequired}
              isClearable={!isDisabled}
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={100}
              disabled={isDisabled}
            />
          </div>
        );
      case 'mapLocation':
        return (
          <div className="location-field-container">
            <div className="d-flex" style={{ gap: '0.5rem' }}>
              <Input
                type="text"
                className="form-control colorBlack"
                placeholder="Coordinates (e.g. 21.1702, 72.8311)"
                value={value}
                onChange={handleInputChange}
                required={isRequired}
                disabled={isDisabled}
                style={{ borderRadius: "8px" }}
              />
              <Button
                type="button"
                color="primary"
                onClick={() => handleGetLocation(fieldKey)}
                disabled={isDisabled}
                style={{ borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '0.25rem', whiteSpace: 'nowrap' }}
              >
                <Navigation size={16} /> Get Location
              </Button>
            </div>
            {value && (
              <div className="mt-2 text-muted small" style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                <MapPin size={14} className="text-danger" />
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(value)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary font-weight-bold"
                  style={{ textDecoration: 'underline' }}
                >
                  View on Google Maps
                </a>
              </div>
            )}
          </div>
        );
      case 'file':
        const isUploaded = value === 'DOCUMENT_EXISTS' || (typeof value === 'string' && value.startsWith('http'));
        return (
          <div className="d-flex flex-column align-items-start w-100" style={{ gap: '0.5rem' }}>
            {isUploaded ? (
              <div className="d-flex align-items-center justify-content-between p-2 border rounded w-100" style={{ backgroundColor: '#f0fdf4', borderColor: '#bbf7d0', borderRadius: '8px' }}>
                <span className="text-success font-weight-bold d-flex align-items-center" style={{ fontSize: '0.95rem' }}>
                  🛡️ Document Uploaded
                </span>
                <Button
                  type="button"
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => {
                    if (isDisabled) return;
                    setResponses(prev => ({
                      ...prev,
                      [fieldKey]: ''
                    }));
                  }}
                  disabled={isDisabled}
                  style={{ padding: '2px 8px', fontSize: '11px', borderRadius: '4px' }}
                >
                  Change
                </Button>
              </div>
            ) : (
              <div className="d-flex align-items-center w-100" style={{ gap: '0.5rem' }}>
                <Input
                  type="file"
                  className="form-control"
                  onChange={async (e) => {
                    if (isDisabled) return;
                    const files = e.target.files;
                    if (files && files.length > 0) {
                      const uploadToast = toast.info("Uploading file...", { autoClose: false });
                      try {
                        const result = await pageItemUploadFile({
                          files,
                          type: CLIENT_TYPE.PUBLIC_FORM
                        });
                        if (result && result.imageUrl) {
                          setResponses(prev => ({
                            ...prev,
                            [fieldKey]: result.imageUrl
                          }));
                        }
                      } catch (err) {
                        toast.error("Failed to upload file");
                      } finally {
                        toast.dismiss(uploadToast);
                      }
                    }
                  }}
                  required={isRequired && !value}
                  disabled={isDisabled}
                  style={{ borderRadius: '8px' }}
                />
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: '#f8f9fa' }}>
        <div className="text-center">
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <h5 className="mt-3 text-muted">Loading registration details...</h5>
        </div>
      </div>
    );
  }

  if (!eventDetail) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: '#f8f9fa' }}>
        <Card className="shadow border-0 p-4 text-center" style={{ maxWidth: '400px', borderRadius: '16px' }}>
          <CardBody>
            <h4 className="text-danger mb-3">Event Not Found</h4>
            <p className="text-muted">The registration link may be incorrect, expired, or the event has been deleted.</p>
          </CardBody>
        </Card>
      </div>
    );
  }

  return (
    <div className="donarbackGround" style={{ minHeight: '100vh', overflowY: 'auto', backgroundColor: '#f3f4f6', padding: '2rem 0' }}>
      <style>{`
        .custom-form-card {
          border-radius: 16px;
          border: none;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
          overflow: hidden;
        }
        .form-control {
          border: 1px solid #d1d5db;
          transition: all 0.2s ease-in-out;
          font-size: 0.95rem;
          padding: 0.6rem 0.75rem;
        }
        .form-control:focus {
          border-color: #4f46e5;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
          outline: none;
        }
        .custom-datepicker-wrapper .react-datepicker-wrapper {
          width: 100%;
        }
        .custom-datepicker-wrapper .react-datepicker__input-container input {
          border-radius: 8px;
        }
        @media (max-width: 576px) {
          .donarbackGround {
            padding: 1rem 0 !important;
          }
          .card-body {
            padding: 1.5rem !important;
          }
        }
      `}</style>
      <div className="container">
        <Row className="justify-content-center">
          <Col lg="8" md="10" sm="12">
            <div className="mb-4 text-center">
              <DonarPublicHeaderComponent orgId={eventDetail.orgId} templeId={eventDetail.templeId} />
            </div>
            <Card className="custom-form-card">
              <div style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)', padding: '2.5rem 2rem', color: '#fff' }}>
                <h2 className="mb-2 font-weight-bold" style={{ fontSize: '1.75rem' }}>{eventDetail.eventName}</h2>
                {eventDetail.description && (
                  <p className="mb-3 opacity-90" style={{ fontSize: '1rem', lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: formatLabelText(eventDetail.description) }} />
                )}
                <div className="d-flex flex-wrap mt-2" style={{ gap: '1.5rem', fontSize: '0.9rem', opacity: '0.85' }}>
                  {eventDetail.eventDate && (
                    <div>
                      <strong>Date:</strong> {eventDetail.eventDate}
                    </div>
                  )}
                  {eventDetail.location && (
                    <div>
                      <strong>Venue:</strong> {eventDetail.location}
                    </div>
                  )}
                </div>
              </div>

              {eventDetail.isRegistrationActive === false || eventDetail.isRegistrationActive === 'false' ? (
                <CardBody className="p-5 text-center" style={{ backgroundColor: '#ffffff' }}>
                  <div style={{ maxWidth: '450px', margin: '0 auto', padding: '2rem 0' }}>
                    <div className="mb-4">
                      <span 
                        style={{ 
                          display: 'inline-flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          width: '72px', 
                          height: '72px', 
                          borderRadius: '50%', 
                          backgroundColor: '#fee2e2',
                          color: '#ef4444',
                          fontSize: '2rem',
                          fontWeight: 'bold'
                        }}
                      >
                        ✕
                      </span>
                    </div>
                    <h3 className="font-weight-bold mb-3" style={{ color: '#1f2937' }}>
                      Registration Closed (નોંધણી બંધ છે)
                    </h3>
                    <p className="text-muted mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      The registration for this event is currently closed or has been stopped by the event administrator.
                      Please contact the organizers for more details.
                    </p>
                  </div>
                </CardBody>
              ) : (
                <CardBody className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  {(() => {
                    const isPaid = paymentStatus === 'paid';
                    const isStandardFieldDisabled = isAlreadyRegistered && (isPaid || !eventDetail?.isEditableByUser);
                    return (
                      <Form onSubmit={onSubmit} className="needs-validation">
                        <h4 className="mb-4 font-weight-bold text-primary border-bottom pb-2" style={{ fontSize: '1.25rem' }}>
                          Participant Details
                        </h4>

                        <Row>
                          <Col md="6" className="mb-3">
                            <Label className="font-weight-bold">Contact No. (મોબાઈલ નંબર)*</Label>
                            <div className="d-flex">
                              <select
                                className="form-control"
                                style={{ width: '90px', borderRadius: "8px 0 0 8px", borderRight: 'none' }}
                                onChange={handleChangeDialCode}
                                value={dialCode}
                                disabled={isMobileFromParam || isAlreadyRegistered}
                              >
                                <option value="">Select</option>
                                {dialCodeJson.map((elem) => (
                                  <option key={elem.code} value={elem.code}>{elem.country} ({elem.code})</option>
                                ))}
                              </select>
                              <Input
                                className="form-control colorBlack"
                                name="contactno"
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                id="contactno"
                                placeholder="Contact No."
                                maxLength={10}
                                value={contactNo}
                                onChange={handleContactChange}
                                style={{ borderRadius: "0 8px 8px 0" }}
                                required
                                disabled={isMobileFromParam || isAlreadyRegistered}
                              />
                            </div>
                          </Col>

                          {nameConfig === 'split' ? (
                            <>
                              <Col md="6" className="mb-3">
                                <Label className="font-weight-bold">First Name (પ્રથમ નામ)*</Label>
                                <Input
                                  className="form-control colorBlack"
                                  name="firstName"
                                  type="text"
                                  placeholder="First Name"
                                  value={firstName}
                                  onChange={(e) => setFirstName(toCamelCase(e.target.value))}
                                  style={{ borderRadius: "8px" }}
                                  required
                                  disabled={isStandardFieldDisabled}
                                />
                              </Col>

                              <Col md="6" className="mb-3">
                                <Label className="font-weight-bold">Last Name (અટક)*</Label>
                                <Input
                                  className="form-control colorBlack"
                                  name="lastName"
                                  type="text"
                                  placeholder="Last Name"
                                  value={lastName}
                                  onChange={(e) => setLastName(toCamelCase(e.target.value))}
                                  style={{ borderRadius: "8px" }}
                                  required
                                  disabled={isStandardFieldDisabled}
                                />
                              </Col>
                            </>
                          ) : (
                            <Col md="6" className="mb-3">
                              <Label className="font-weight-bold">Full Name (નામ)*</Label>
                              <Input
                                className="form-control colorBlack"
                                name="fullname"
                                type="text"
                                placeholder="Full Name"
                                value={name}
                                onChange={(e) => setName(toCamelCase(e.target.value))}
                                style={{ borderRadius: "8px" }}
                                required
                                disabled={isStandardFieldDisabled}
                              />
                            </Col>
                          )}

                          <Col md="6" className="mb-3">
                            <Label className="font-weight-bold">Gender (લિંગ)*</Label>
                            <Input
                              type="select"
                              className="form-control colorBlack"
                              value={gender}
                              onChange={(e) => setGender(e.target.value)}
                              style={{ borderRadius: "8px" }}
                              required
                              disabled={isStandardFieldDisabled}
                            >
                              <option value="male">Male(પુરુષ)</option>
                              <option value="female">Female(સ્ત્રી)</option>
                            </Input>
                          </Col>

                          <Col md="6" className="mb-3">
                            <Label className="font-weight-bold">City (શહેર)*</Label>
                            <Input
                              innerRef={cityRef}
                              className="form-control colorBlack"
                              name="city"
                              type="text"
                              placeholder="City"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              style={{ borderRadius: "8px" }}
                              required
                              disabled={isStandardFieldDisabled}
                            />
                          </Col>

                          <Col md="12" className="mb-3">
                            <Label className="font-weight-bold">Address (સરનામું)*</Label>
                            <Input
                              className="form-control colorBlack"
                              name="address"
                              type="textarea"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                              style={{ borderRadius: "8px", minHeight: '80px' }}
                              required
                              disabled={isStandardFieldDisabled}
                            />
                          </Col>
                        </Row>

                        {eventDetail.formFields && eventDetail.formFields.filter(f => !['name', 'mobile', 'gender', 'address', 'city'].includes(f.fieldKey.toLowerCase())).length > 0 && (
                          <>
                            <h4 className="mt-4 mb-4 font-weight-bold text-primary border-bottom pb-2" style={{ fontSize: '1.25rem' }}>
                              Additional Information
                            </h4>
                            <Row>
                              {eventDetail.formFields
                                .filter(f => !['name', 'mobile', 'gender', 'address', 'city'].includes(f.fieldKey.toLowerCase()) && !f.isToken)
                                .map((field) => {
                                  const isRequired = field.required;
                                  const fieldKey = field.fieldKey;

                                  if (field.type === 'label') {
                                    return (
                                      <Col key={fieldKey} md="12" className="mb-3">
                                        <div
                                          className="alert alert-info p-3 mb-0"
                                          style={{ borderRadius: "8px", fontSize: "0.95rem", borderLeft: "4px solid #0dcaf0", backgroundColor: "#f0fafd", color: "#055160", lineHeight: "1.6", textAlign: "left" }}
                                          dangerouslySetInnerHTML={{ __html: formatLabelText(field.label) }}
                                        />
                                      </Col>
                                    );
                                  }

                                  return (
                                    <Col key={fieldKey} md={field.type === 'textarea' || field.type === 'mapLocation' ? "12" : "6"} className="mb-3">
                                      <Label className="font-weight-bold">
                                        {field.label} {isRequired && <span className="text-danger">*</span>}
                                      </Label>
                                      {renderDynamicField(field)}
                                    </Col>
                                  );
                                })}
                            </Row>
                          </>
                        )}

                        {eventDetail && eventDetail.isPaymentEnabled && (
                          <Row className="mt-4 mb-2">
                            <Col xs="12">
                              <div
                                className="p-3 d-flex justify-content-between align-items-center"
                                style={{
                                  backgroundColor: '#f5f3ff',
                                  border: '1px solid #ddd6fe',
                                  borderRadius: '8px',
                                  fontWeight: '600',
                                  color: '#4f46e5'
                                }}
                              >
                                <span style={{ fontSize: '0.95rem' }}>Registration Fee (નોંધણી ફી):</span>
                                <span style={{ fontSize: '1.25rem', fontWeight: '800' }}>
                                  ₹{calculateRegistrationFee().toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                </span>
                              </div>
                            </Col>
                          </Row>
                        )}

                        <Row className="mt-4">
                          <Col xs="12">
                            {isAlreadyRegistered && (
                              isPaid ? (
                                eventDetail.isEditableByUser ? (
                                  <div 
                                    className="p-3 mb-4 d-flex align-items-center" 
                                    style={{ 
                                      borderRadius: "10px", 
                                      backgroundColor: "#eff6ff", 
                                      border: "1px solid #bfdbfe", 
                                      color: "#1e40af", 
                                      boxShadow: "0 2px 4px rgba(59, 130, 246, 0.08)" 
                                    }}
                                  >
                                    <span style={{ fontSize: "1.4rem", marginRight: "0.75rem", lineHeight: 1 }}>ℹ️</span>
                                    <div>
                                      <div style={{ fontWeight: "700", fontSize: "0.95rem", color: "#1e3a8a" }}>
                                        Registration Already Completed (નોંધણી થઈ ગઈ છે)
                                      </div>
                                      <div style={{ marginTop: "2px", fontSize: "0.88rem", color: "#1e40af" }}>
                                        You have already registered for this event. You can modify your eligible details below and update your registration. (તમે આ ઇવેન્ટ માટે પહેલાથી જ નોંધણી કરાવી લીધી છે. તમે નીચે દર્શાવેલ વિગતોમાં ફેરફાર કરી શકો છો.)
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div 
                                    className="p-3 mb-4 d-flex align-items-center" 
                                    style={{ 
                                      borderRadius: "10px", 
                                      backgroundColor: "#fef2f2", 
                                      border: "1px solid #fecaca", 
                                      color: "#991b1b", 
                                      boxShadow: "0 2px 4px rgba(239, 68, 68, 0.08)" 
                                    }}
                                  >
                                    <span style={{ fontSize: "1.4rem", marginRight: "0.75rem", lineHeight: 1 }}>❌</span>
                                    <div>
                                      <div style={{ fontWeight: "700", fontSize: "0.95rem", color: "#7f1d1d" }}>
                                        Registration Locked (નોંધણી પૂર્ણ થયેલ છે)
                                      </div>
                                      <div style={{ marginTop: "2px", fontSize: "0.88rem", color: "#991b1b" }}>
                                        You are already registered for this event, and modifications are not permitted. (તમે આ ઇવેન્ટ માટે પહેલાથી જ નોંધણી કરાવી લીધી છે અને તેમાં ફેરફાર કરવાની પરવાનગી નથી.)
                                      </div>
                                    </div>
                                  </div>
                                )
                              ) : (
                                <div 
                                  className="p-3 mb-4 d-flex align-items-center" 
                                  style={{ 
                                    borderRadius: "10px", 
                                    backgroundColor: "#fffbe6", 
                                    border: "1px solid #ffe58f", 
                                    color: "#873800", 
                                    boxShadow: "0 2px 4px rgba(250, 173, 20, 0.12)" 
                                  }}
                                >
                                  <span style={{ fontSize: "1.4rem", marginRight: "0.75rem", lineHeight: 1 }}>⚠️</span>
                                  <div>
                                    <div style={{ fontWeight: "700", fontSize: "0.95rem", color: "#612500" }}>
                                      Pending Payment (પાછલું પેમેન્ટ બાકી છે)
                                    </div>
                                    <div style={{ marginTop: "2px", fontSize: "0.88rem", color: "#873800" }}>
                                      તમારું પાછલું પેમેન્ટ બાકી છે. કૃપા કરીને નીચે આપેલા બટન પર ક્લિક કરીને પેમેન્ટ પૂર્ણ કરો. (Your previous payment is pending. Please click below to complete payment.)
                                    </div>
                                  </div>
                                </div>
                              )
                            )}

                            {errorMessage && (
                              <div 
                                className="p-3 mb-4 d-flex align-items-center" 
                                style={{ 
                                  borderRadius: "10px", 
                                  backgroundColor: "#fef2f2", 
                                  border: "1px solid #fecaca", 
                                  color: "#991b1b",
                                  boxShadow: "0 2px 4px rgba(239, 68, 68, 0.08)"
                                }}
                              >
                                <span style={{ fontSize: "1.2rem", marginRight: "0.75rem", lineHeight: 1 }}>⚠️</span>
                                <div style={{ fontSize: "0.9rem", fontWeight: "600", color: "#991b1b" }}>{errorMessage}</div>
                              </div>
                            )}

                            <Button
                              type="submit"
                              color="primary"
                              block
                              disabled={click || (isAlreadyRegistered && isPaid && !eventDetail.isEditableByUser)}
                              style={{
                                padding: '0.75rem',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                background: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)',
                                border: 'none',
                                boxShadow: '0 4px 6px -1px rgba(79, 70, 229, 0.2)'
                              }}
                            >
                              {click ? (
                                <Spinner size="sm" />
                              ) : isAlreadyRegistered && isPaid ? (
                                'Update Registration (અપડેટ કરો)'
                              ) : eventDetail && eventDetail.isPaymentEnabled ? (
                                `Pay ₹${calculateRegistrationFee().toLocaleString('en-IN', { minimumFractionDigits: 2 })} ${isAlreadyRegistered && !isPaid ? '(પેમેન્ટ પૂર્ણ કરો)' : '& Register'}`
                              ) : (
                                'Submit Registration'
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    );
                  })()}
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default EventPublicRegistration;
